import React, { useState } from "react";

import "../components/about/styles/experience.css";

const experiences = [
    {
        initials: "MD",
        title: "The Mindset Development Institute",
        role: "Founder",
        duration: "Since 2019",
        description:
            "Developed 40+ mindset models for critical thinking in leadership, relationships, communication and DEIB.",
        link: "https://mindsetdevelopmentinstitute.com/",
    },
    {
        initials: "SX",
        title: "Sewells MSX International",
        role: "Associate Partner, Facilitator",
        duration: "Since 2021",
        description:
            "Facilitates leadership, emotional intelligence, effective communication and conflict resolution programmes.",
        link: "https://www.msxi.com/",
    },
    {
        initials: "PT",
        title: "Preferental Technologies",
        role: "Non-Executive Director",
        duration: "Board Member",
        description:
            "Board member of a multi-platform property tech group of companies.",
        link: "https://www.preferental.com",
    },
    {
        initials: "PS",
        title: "Professional Speakers Association of Southern Africa",
        role: "Vice-President, EXCO Member",
        duration: "2023 - 2024 term · Member since 2020",
        description:
            "Served as VP for the 2023-2024 term; EXCO member and professional member since 2020.",
        link: "https://www.psasouthernafrica.co.za",
    },
    {
        initials: "SM",
        title: "Success Mindset Summit",
        role: "Founder",
        duration: "",
        description:
            "Hosts multicultural events including women and young people in Fintech, Proptech and Professional Speaking.",
        link: null,
    },
    {
        initials: "MC",
        title: "Men Of Change Movement",
        role: "Founder",
        duration: "",
        description:
            "Addresses issues affecting men through events, mentorship and the Men Of Change Podcast.",
        link: "https://www.youtube.com/@MenOfChange-g9j",
    },
    {
        initials: "GA",
        title: "GIBS Alumni Speakers Association",
        role: "Executive Member",
        duration: "",
        description: "Executive member supporting alumni speaker engagements.",
        link: null,
    },
    {
        initials: "IX",
        title: "INX Prime TV",
        role: "Presenter, Monday Motivation",
        duration: "DSTV Channel 345",
        description: "Presents Monday Motivation TV on the INX Prime TV channel.",
        link: null,
    },
];

const INITIAL_COUNT = 3;

const Experience = () => {
    const [showAll, setShowAll] = useState(false);

    const visibleExperiences = showAll
        ? experiences
        : experiences.slice(0, INITIAL_COUNT);

    return (
        <div className="experience-section">
            <div className="experience-heading">Experience</div>

            <div className="experience-grid">
                {visibleExperiences.map((exp) => (
                    <div className="experience-card" key={exp.title}>
                        <div className="experience-card-header">
                            <div className="experience-avatar">{exp.initials}</div>
                            <div className="experience-heading-block">
                                <div className="experience-title">{exp.title}</div>
                                <div className="experience-role">{exp.role}</div>
                                {exp.duration && (
                                    <div className="experience-duration">{exp.duration}</div>
                                )}
                            </div>
                        </div>
                        <p className="experience-description">{exp.description}</p>
                        {exp.link && (
                            <a
                                href={exp.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="experience-link"
                            >
                                Visit site
                            </a>
                        )}
                    </div>
                ))}
            </div>

            {experiences.length > INITIAL_COUNT && (
                <div className="experience-toggle-container">
                    <button
                        className="experience-toggle-button"
                        onClick={() => setShowAll(!showAll)}
                    >
                        {showAll ? "View less" : "View more"}
                    </button>
                </div>
            )}
        </div>
    );
};

export default Experience;